//Show modal on page load
// $(window).on('load',function(){
//   if($("#coupon-details-custom")){
//   if (!sessionStorage.getItem('shown-modal')){
//     $("#coupon-details-custom").addClass("show");
//     sessionStorage.setItem('shown-modal', 'true');
//   }
//   else{
//     sessionStorage.setItem('shown-modal', 'false');
//     $("#coupon-details-custom").removeClass("show");
//   }
//   }
// });


$(document).ready(function () {
  $("#nav-language-btn, #footer-language-btn").click(function(){
    $(this).find(".wpml-ls-statics-shortcode_actions").toggleClass("is-visible")
  });
  
    $('.where-to-buy-btn').click(function() {
	  $('.retailer-logo-wrapper').slideToggle();
  });

  //    $(".site-header").css({"top":46})
  //      $(window).scroll(function() {
  //       $(".site-header").css({"top":0})
  //       if($(window).scrollTop() == 0){
  //       	$(".site-header").css({"top":46})
  //       }
  //      });
  var promobarHeight = 0;
  var promoAndNavHeight = 0;

  /* Top nav - show while hover */
  if ($(window).width() > 960) {
    $(".site-header .menu-item").hover(function(){
      $(this).find(".sub-menu-toggle").trigger("click");
    });
  }
  /* End */

  /* Set product tab items nav height */

  
  if(document.querySelector('.easy-notification-bar')){
    var pb = document.querySelector('.easy-notification-bar');
    
      if(pb.classList.contains('display_pb')) {
       promobarHeight = $(".easy-notification-bar").height();
       $("#masthead").css({"top": promobarHeight});
       $("#search_overlay").css({"top": promobarHeight});
      }
    }
    

      var topNavHeight = $("#masthead").height();
      NavHeight = parseInt(topNavHeight)
    $(".product-details-navigation").css({"top": NavHeight});
  /* Set product tab items nav height */



  var elementTop = 0;
  var elementBottom = 0;
  var lastScrollTop = 0;
  $(window).scroll(function(event){

    // /* Adding the class "sticky" in Top nav */
    // if ($(this).scrollTop() > 1){  
    //   $('.easy-notification-bar').addClass("sticky");
    // } else {
    //   $('.easy-notification-bar').removeClass("sticky");
    // }
    // /* End */
    if ($(this).scrollTop() > 1){  
      $("#masthead").css({"top": "0px"});
      $("#search_overlay").css({"top": "0px"});
      } else {
          $("#masthead").css({"top": promobarHeight});
          $("#search_overlay").css({"top": promobarHeight});
      }
    /* Hide top nave on scroll */
    // var st = $(this).scrollTop();

    // if($("#features-tab").length) {
    //   var elementTop = $("#features-tab").offset().top;
    //   var elementBottom = elementTop + $("#features-tab").outerHeight();
    // }
    // // added for accessories fix T.th     
    // else{
    //    if($("#features-tab").length){
    //     var elementTop = $("#reviews-tab").offset().top;
    //     var elementBottom = elementTop + $("#reviews-tab").outerHeight();
    //   }
    // }

    // var viewportTop = $(window).scrollTop();
    // var viewportBottom = viewportTop + $(window).height();

    // if ( $(this).scrollTop() >= ( elementTop - parseInt(promoAndNavHeight+100))) {

    //   var viewportTop = $(this).scrollTop();
    //   var viewportBottom = viewportTop + $(this).height();

    //   if(elementBottom > viewportTop && elementTop < viewportBottom) {
    //     $(".product-details-navigation").css({"top": promobarHeight});
    //   }
    //   if (st > lastScrollTop){
    //     $("#masthead").css({"top": "-200px"});
    //   } else {
    //     $(".product-details-navigation").css({"top": promoAndNavHeight});
    //     $("#masthead").css({"top": promobarHeight});

    //   }
    // } else if (st > lastScrollTop){
    //   $("#masthead").css({"top": "-200px"});
    // } else {
    //   $("#masthead").css({"top": promobarHeight});
    // }
    // lastScrollTop = st;
    // /* Hide top nave on scroll */

  });
//    promo bar commented on header-t.liquid
       $("#promo-bar-close").click(function(e){
         e.preventDefault();
         $(".easy-notification-bar").slideUp();
         $(".easy-notification-bar").attr("data-value","flase");
         $("#masthead").css({"top":0})
       });
    
  
  $(".easy-notification-bar-message a.coupon_details").click(function(){
    $("#coupon-details").addClass("show")
  });
  $("#coupon-details .close-btn, .hide_the_popup").click(function(){
    $("#coupon-details").removeClass("show")
  })

  $("#coupon-details-custom .close-btn, .hide_the_popup").click(function(){
    $("#coupon-details-custom").removeClass("show")
  })
  $(".site-footer .grid-item h3").click(function () {
    $(this).parent("div").toggleClass("active");
  }),
    $("#header_search").click(function (e) {
    e.preventDefault(), $("#search_overlay").addClass("active");
  }),
    $("#header_search_close").click(function (e) {
    e.preventDefault(), $("#search_overlay").removeClass("active");
  }),
    $(".back-to-top").on("click", function (e) {
    e.preventDefault(), $("html, body").animate({ scrollTop: 0 }, "300");
  }),
    $("button[data-section='features-tab']").click(function () {
    $(this).addClass("is-active"),
      $("button[data-section='specs-tab']").removeClass("is-active"),
      $("button[data-section='reviews-tab']").removeClass("is-active"),
      $("button[data-section='support-tab']").removeClass("is-active"),
      $("#features-tab").addClass("tab-active"),
      $("#specs-tab").removeClass("tab-active"),
      $("#support-tab").removeClass("tab-active"),
      $("#reviews-tab").removeClass("tab-active"),
      window.scrollTo({ top: document.querySelector("#features-tab").offsetTop - 100, behavior: "smooth" });
  }),
    $("button[data-section='specs-tab']").click(function () {
    $(this).addClass("is-active"),
      $("button[data-section='features-tab']").removeClass("is-active"),
      $("button[data-section='reviews-tab']").removeClass("is-active"),
      $("button[data-section='support-tab']").removeClass("is-active"),
      $("#specs-tab").addClass("tab-active"),
      $("#support-tab").removeClass("tab-active"),
      $("#features-tab").removeClass("tab-active"),
      $("#reviews-tab").removeClass("tab-active"),
      window.scrollTo({ top: document.querySelector("#specs-tab").offsetTop - 100, behavior: "smooth" });
  }),
    $("button[data-section='support-tab']").click(function () {
    $(this).addClass("is-active"),
      $("button[data-section='features-tab']").removeClass("is-active"),
      $("button[data-section='specs-tab']").removeClass("is-active"),
      $("button[data-section='reviews-tab']").removeClass("is-active"),
      $("#support-tab").addClass("tab-active"),
      $("#specs-tab").removeClass("tab-active"),
      $("#features-tab").removeClass("tab-active"),
      $("#reviews-tab").removeClass("tab-active"),
      window.scrollTo({ top: document.querySelector("#support-tab").offsetTop - 100, behavior: "smooth" });
  }),
    $("button[data-section='reviews-tab'], .bv_main_container_row_flex").click(function () {
    $(this).addClass("is-active"),
      $("button[data-section='features-tab']").removeClass("is-active"),
      $("button[data-section='support-tab']").removeClass("is-active"),
      $("button[data-section='specs-tab']").removeClass("is-active"),
      $("#reviews-tab").addClass("tab-active"),
      $("#support-tab").removeClass("tab-active"),
      $("#features-tab").removeClass("tab-active"),
      $("#specs-tab").removeClass("tab-active"),
      window.scrollTo({ top: document.querySelector("#reviews-tab").offsetTop - 100, behavior: "smooth" });
  }),
    $(".menu-toggle-burger").click(function () {
    $(this).parent().parent().addClass("toggled");
    $("html").css("overflow","hidden");
  }),
    $(".menu-toggle-close").click(function () {
    $(this).parent().parent().removeClass("toggled");
    $("html").css("overflow","visible");
  }),
    //         $(".site-header .menu-item").hover(function(){
    //           $(this).toggleClass("sub-menu-visible");
    //         });
    $("site-header .menu-item").hover(
    function () {
      $(this).addClass('sub-menu-visible');
    }, 
    function () {
      $(this).removeClass('sub-menu-visible');
    }
  );

  $(".sub-menu-toggle").on("click", function(e) {
    e.preventDefault(), e.stopPropagation(), $(this).parent().hasClass("sub-menu-visible") ? $(".sub-menu-toggle").parent().removeClass("sub-menu-visible") : ($(".sub-menu-toggle").parent().removeClass("sub-menu-visible"), $(this).parent().toggleClass("sub-menu-visible"))
  }), $(document).click(function() {
    $(".sub-menu-toggle").parent().removeClass("sub-menu-visible")
  }), $(".sub-menu").click(function(e) {
    e.stopPropagation()
  }),
    $(document).click(function () {
    $(".site-header .menu-item").removeClass("sub-menu-visible");
  }),
    $(".sub-menu").click(function (e) {
    e.stopPropagation();
  }),
    $(".site-footer-menu>.menu li.menu-item-has-children>a").click(function () {
    $(this).parent().toggleClass("submenu-is-active");
  }),
    $(".site-footer .site-footer-contact h4").click(function () {
    $(this).parent().toggleClass("submenu-is-active");
  }),
    $(window).width() < 576 &&
    ($(".site-footer .menu-item-has-children>a").click(function (e) {
    e.preventDefault();
  }),
     $(".site-header .menu-item a").click(function (e) {})),
    $(".specs-list-plus").click(function () {
    $(this).removeClass("is-active"), $(this).next(".specs-list-minus").addClass("is-active"), $(this).parent().next(".specs-section .specs-section-left .specs-section-list ul").addClass("is-active");
  }),
    $(".specs-list-minus").click(function () {
    $(this).removeClass("is-active"), $(this).prev(".specs-list-plus").addClass("is-active"), $(this).parent().next(".specs-section .specs-section-left .specs-section-list ul").removeClass("is-active");
  });
  
//   video modals

  $(".feature-block-video-toggle").each(function(t) {
    var iframeSrc = $(this).next(".feature-block-video-modal").find("iframe").attr("src");
    var videoSrc = $(this).next(".feature-block-video-modal").find("source").attr("src");
    $(this).on("click", function(t){
     t.preventDefault();
      $(this).next(".feature-block-video-modal").find("source").attr("src", videoSrc);
      $(this).next(".feature-block-video-modal").find("iframe").attr("src", iframeSrc);
      $(this).next(".feature-block-video-container").find("video").trigger('play');
      $(this).next(".feature-block-video-modal").addClass("video-is-active"),
      $("body").addClass("has-video-active");
    });
  });

      
  $(".feature-block-video-overlay").each(function(e) {
    $(this).on("click", function(e){
    e.preventDefault(), $(this).parent(".feature-block-video-modal").removeClass("video-is-active"),
       $(this).next(".feature-block-video-container").find("source").attr("src", "");
       $(this).next(".feature-block-video-container").find("iframe").attr("src", "");
       $(this).next(".feature-block-video-container").find("video").trigger('pause');
      $("body").removeClass("has-video-active");
    });
  });
  
//   end video modals
  var t = $(".retailer").innerWidth();
  $(".retailers-arrow-right").click(function () {
    let e = parseFloat($(".retailers-slider").scrollLeft()) + t;
    $(".retailers-slider").scrollLeft(e);
  }),
    $(".retailers-arrow-left").click(function () {
    let e = parseFloat($(".retailers-slider").scrollLeft()) - t;
    $(".retailers-slider").scrollLeft(e);
  }),
    $(document).on("click", "#flyby-close-btn1, #flyby-close-btn", function () {
    $("#ajaxifyDrawer").removeClass("is-visible");
  }),

    $("#carousel").flexslider({ animation: "slide", controlNav: !1, animationLoop: !1, slideshow: !1, itemWidth: 100, itemMargin: 5, asNavFor: "#slider" }),
    $("#slider").flexslider({ animation: "slide", controlNav: !1, animationLoop: !1, slideshow: !1, sync: "#carousel" }),
    $(".qtyplus").click(function (e) {
    e.preventDefault(), (fieldName = $(this).attr("field"));
    var t = parseInt($("input[id=" + fieldName + "]").val());
    isNaN(t) ? $("input[id=" + fieldName + "]").val(0) : $("input[id=" + fieldName + "]").val(t + 1);
  }),
    $(".qtyminus").click(function (e) {
    e.preventDefault(), (fieldName = $(this).attr("field"));
    var t = parseInt($("input[id=" + fieldName + "]").val());
    !isNaN(t) && t > 0 ? $("input[id=" + fieldName + "]").val(t - 1) : $("input[id=" + fieldName + "]").val(0);
  });
});
// features carousel
const featureStatsCarousels = document.querySelectorAll(".features-stats-carousel");
if (featureStatsCarousels.length > 1) {
  featureStatsCarousels.forEach(carousel=>{
    const carouselNav = carousel.querySelector(".features-stats-carousel-navigation .nav-buttons-wrapper");
    const featureStatsSlides = [...carousel.querySelectorAll(".feature-block")];
    const arrowLeft = carousel.querySelector(".carousel-nav-left-arrow");
    const arrowRight = carousel.querySelector(".carousel-nav-right-arrow");
    let currentIndex = 0;
    featureStatsSlides.forEach((slide,i)=>{
      if (i !== 0)
        slide.style.display = "none";
    }
                              );
    const cleanSlideName = string=>{
      return string.toLowerCase().replace(/ /g, "_");
    }
    ;
    const goToSlide = id=>{
      featureStatsSlides.forEach(slide=>{
        let name = cleanSlideName(slide.dataset.slidename);
        slide.style.display = name === id ? "flex" : "none";
      }
                                );
    }
    ;
    const setActiveNav = id=>{
      let buttons = carouselNav.querySelectorAll("button");
      buttons.forEach(button=>{
        button.value === id ? button.classList.add("is-active") : button.classList.remove("is-active");
      }
                     );
    }
    ;
    const setNavigation = ()=>{
      featureStatsSlides.forEach((slide,i)=>{
        let button = document.createElement("button");
        let name = cleanSlideName(slide.dataset.slidename);
        button.innerText = slide.dataset.slidename;
        button.value = name;
        button.addEventListener("click", ({target})=>{
          currentIndex = i;
          setActiveNav(target.value);
          goToSlide(target.value);
        }
                               );
        carouselNav.append(button);
      }
                                );
      arrowLeft.addEventListener("click", ()=>{
                                 if (currentIndex === 0) {
        currentIndex = featureStatsSlides.length - 1;
      } else {
        currentIndex -= 1;
      }
      let currentSlide = cleanSlideName(featureStatsSlides[currentIndex].dataset.slidename);
      setActiveNav(currentSlide);
      goToSlide(currentSlide);
    }
    ); 
    arrowRight.addEventListener("click", ()=>{
                                if (currentIndex === featureStatsSlides.length - 1) {
      currentIndex = 0;
    } else {
      currentIndex += 1;
    }
    let currentSlide = cleanSlideName(featureStatsSlides[currentIndex].dataset.slidename);
    setActiveNav(currentSlide);
    goToSlide(currentSlide);
  }
                               );
}
;
let initialSlide = cleanSlideName(featureStatsSlides[currentIndex].dataset.slidename);
setNavigation();
setActiveNav(initialSlide);
goToSlide(initialSlide);
}
);
}
// bvCallback must be used when interacting with BV via JavaScript and using the `async` attribute. 
window.bvCallback = function (BV) {

  // Register a function to be called when a BV feature needs to display the R&R element, such as Rating Summary's stars
  BV.swat_reviews.on('show', function () {
    // If the R&R container is hidden (such as behind a tab), put code here to make it visible (open the tab)
    $('#reviews-tab').addClass("tab-active");
    $("button[data-section='reviews-tab']").addClass("is-active"),
      $("button[data-section='features-tab']").removeClass("is-active"),
      $("button[data-section='support-tab']").removeClass("is-active"),
      $("button[data-section='specs-tab']").removeClass("is-active"),
      $("#reviews-tab").addClass("tab-active"),
      $("#support-tab").removeClass("tab-active"),
      $("#features-tab").removeClass("tab-active"),
      $("#specs-tab").removeClass("tab-active"),
      window.scrollTo({ top: document.querySelector("#reviews-tab").offsetTop - 100, behavior: "smooth" });
  });

};
jQuery(document).ready(function() {
  jQuery("body").on("change", ".info-block .wher_are_you_select_country select", function() {
      var count = jQuery(this).val();
      jQuery(".country_details").removeClass("active_country");
      jQuery("." + count + "details").addClass("active_country")
  });
  jQuery("body").on("change", ".info-block .sp_select_country select", function() {
      var count = jQuery(this).val();
      jQuery(".sp_details").removeClass("active_country");
      jQuery("." + count + "_sp").addClass("active_country")
  });

  jQuery(".section-title-search button").click(function() {
      var v = jQuery(this).closest("div.section-title-search").find("input").val();
      window.location.href = "https://support.neatorobotics.com/hc/en-us/search?query=" + v;
      return !1
  })
// header icons mobile
$(window).on("load resize", function () {
  if( $('.icon-bar__container').length ){
    if ($(window).width() < 769) {
    $('.icon-bar__container').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      easing: 'linear',
      autoplay: true,
      autoplaySpeed: 5000,
      arrows:false,
    });
  }
  else {
    $('.icon-bar__container').slick('unslick');
  }
}
});
  $('.slider').slick({
    infinite: false,
    slidesToShow: 1,
    easing: 'linear',
    arrows:true,
    dots:true,
    appendDots: $('.cgb-gallery-dots'),
    prevArrow: $('.cgb-gallery-left-arrow'),
    nextArrow: $('.cgb-gallery-right-arrow'),
  });

  $('#cgb-news-carousel-eksp1 .cgb-gallery-slides').slick({
    infinite: false,
    slidesToShow: 1,
    easing: 'linear',
    arrows:true,
    dots:true,
    appendDots: $('.cgb-gallery-dots'),
    prevArrow: $('.cgb-gallery-left-arrow'),
    nextArrow: $('.cgb-gallery-right-arrow'),
  });
})
$(document).ready(function() {

$('.single-item').slick({
dots: true,
infinite: true,
arrows: true
});

});
// Warranty page tabs
const sectionTitleTabs = document.querySelectorAll(".section-title-tabs");
if (sectionTitleTabs.length >= 1) {
    sectionTitleTabs.forEach(section => {
        const headerTabs = [...section.querySelectorAll(".section-title-tab")];
        const headerTabsNav = section.querySelector(".section-title-tabs-nav .tabs-wrapper");
        const arrowLeft = section.querySelector(".tabs-left-arrow");
        const arrowRight = section.querySelector(".tabs-right-arrow");
        let currentIndex = 0;
        const cleanSlideName = string => {
            return string.toLowerCase().replace(/ /g, "_");
        };
        const goToTab = id => {
            headerTabs.forEach(tab => {
                let name = cleanSlideName(tab.dataset.tabid);
                tab.style.display = name === id ? "block" : "none";
            });
        };
        const setActiveNav = id => {
            let buttons = headerTabsNav.querySelectorAll("button");
            buttons.forEach(button => {
                button.value === id ? button.classList.add("is-active") : button.classList.remove("is-active");
            });
        };
        const setNavigation = () => {
            headerTabs.forEach((tab, i) => {
                let tabId = cleanSlideName(tab.dataset.tabid);
                let button = document.createElement("button");
                button.innerText = tab.dataset.tabid;
                button.value = tabId;
                button.addEventListener("click", ({
                    target
                }) => {
                    currentIndex = i;
                    setActiveNav(target.value);
                    goToTab(target.value);
                });
                headerTabsNav.append(button);
            });
            arrowLeft.addEventListener("click", () => {
                if (currentIndex === 0) return;
                currentIndex -= 1;
                let currentTab = cleanSlideName(headerTabs[currentIndex].dataset.tabid);
                setActiveNav(currentTab);
                goToTab(currentTab);
            });
            arrowRight.addEventListener("click", () => {
                if (currentIndex === headerTabs.length - 1) return;
                currentIndex += 1;
                let currentTab = cleanSlideName(headerTabs[currentIndex].dataset.tabid);
                setActiveNav(currentTab);
                goToTab(currentTab);
            });
        };
        let initialSlide = headerTabs[currentIndex].dataset.tabid.toLowerCase().replace(/ /g, "_");
        setNavigation();
        setActiveNav(initialSlide);
        goToTab(initialSlide);
    });
}


// PRESS CENTER PAGE
const mediaAssetsList = document.querySelector(".media-assets-list");
if (mediaAssetsList) {
    const wrapper = document.querySelector(".media-assets-wrapper");
    const entries = [...document.querySelectorAll(".media-assets-entry")];
    const tabButtons = document.querySelectorAll(".media-assets-tabs-buttons button");
    const tabUnderline = document.querySelector(".media-assets-tab-underline");
    const getHighestGrayBox = items=>{
        document.body.style.setProperty("--pressCenterLink", "");
        let heightsList = [];
        for (let item of items) {
            heightsList.push(item.lastElementChild.clientHeight);
        }
        let maxItemHeight = Math.max(...heightsList);
        document.body.style.setProperty("--pressCenterLink", maxItemHeight + "px");
    }
    const setTabActiveContent = tab=>{
        let animationDelay = 50;
        let currentAssets = entries.filter(entry=>entry.dataset.slug === tab);
        wrapper.innerHTML = "";
        currentAssets.forEach(node=>{
            node.style.animationDelay = `${animationDelay}ms`;
            node.classList.add("ready-to-display");
            wrapper.append(node);
            animationDelay += 50;
        }
        );
        getHighestGrayBox(currentAssets);
    }
    ;
    const setActiveUnderline = activeElement=>{
        const {offsetLeft, clientWidth} = activeElement;
        tabUnderline.style.left = `${offsetLeft}px`;
        tabUnderline.style.width = `${clientWidth}px`;
    }
    ;
    const setActiveState = target=>{
        tabButtons.forEach(button=>{
            if (button.classList.contains("tab-active"))
                button.classList.remove("tab-active");
        }
        );
        target.classList.add("tab-active");
        setActiveUnderline(target);
    }
    ;
    const setWrapperClass = category=>{
        const classes = ["press-releases", "brochures"];
        category === classes[1] ? wrapper.classList.add(`has-${classes[1]}`) : wrapper.classList.remove(`has-${classes[1]}`);
    }
    ;
    const setMobileFiltersToggle = ()=>{
        let categoriesBar = document.querySelector(".media-assets-tabs");
        let toggle = categoriesBar.querySelector("svg");
        toggle.addEventListener("click", ()=>{
            categoriesBar.classList.toggle("tab-selection-visible");
        }
        );
        document.addEventListener("click", ({target})=>{
            if (!categoriesBar.contains(target))
                categoriesBar.classList.remove("tab-selection-visible");
        }
        );
    }
    ;
    let initialActiveTab = document.querySelector("button.tab-active");
    const setCurrentTab = (currentTab=initialActiveTab)=>{
        setWrapperClass(currentTab.value);
        setTabActiveContent(currentTab.value);
        setActiveState(currentTab);
    }
    ;
    tabButtons.forEach(button=>{
        button.addEventListener("click", ({target})=>setCurrentTab(target));
    }
    );
    window.addEventListener("resize", ()=>{
        let currentActiveTab = document.querySelector("button.tab-active");
        if (window.innerWidth >= 768)
            setActiveUnderline(currentActiveTab);
    }
    );
    setMobileFiltersToggle();
    setCurrentTab();
}

const heroCarouselScrollBtn = document.querySelector(".hero-image button");
if (heroCarouselScrollBtn) {
    const styles = getComputedStyle(document.documentElement);
    const getHeaderHeight = ()=>{
        let headerHeightCustomProperty = styles.getPropertyValue("--headerHeight");
        return Number(headerHeightCustomProperty.substring(0, headerHeightCustomProperty.length - 2));
    }
    ;
    heroCarouselScrollBtn.addEventListener("click", ()=>{
        window.scrollBy({
            top: window.innerHeight - getHeaderHeight(),
            behavior: "smooth"
        });
    }
    );
}
// search
$(document).ready(function() {
  // Tab click
  $('.search-page-button').click(function() {
      var tab_name = $(this).data('category');

      $('.search-page-button').removeClass('is-active');
      $(this).addClass('is-active');

      $('.search-page-body').removeClass('is-active');
      $('.search-page-body[data-category="'+ tab_name +'"]').addClass('is-active');
  });

  // Pagination
  $('.search-page-pagination button').click(function() {
      var obj = $(this);
      var pagination = obj.parents('.search-page-pagination');

      var type = $(this).parents('.search-page-body').data('category');
      var page = $(this).data('page');
      var q = $('.header-search-module-overlay input[type="search"]').val();

      if(page === 'prev') {
          page = parseInt(pagination.find('button.is-active').html()) - 1;
      }
      if(page === 'next') {
          page = parseInt(pagination.find('button.is-active').html()) + 1;
      }

      var url = 'https://help.neatorobotics.com/wp-admin/admin-ajax.php/?action=search_pagination&type='+ type +'&page='+ page +'&q='+ q;

      $('.search_loading').fadeIn(500);

      $.ajax({
          url: url,
          dataType: 'html',
          success: function(data) {
              if(page !== 1) {
                  pagination.find('button.prev-button').show();
              } else {
                  pagination.find('button.prev-button').hide();
              }

              if(pagination.find('button[data-page="'+ page +'"]').is(':last-child')) {
                  pagination.find('button.next-button').hide();
              } else {
                  pagination.find('button.next-button').show();
              }

              pagination.find('button.is-active').removeClass('is-active');
              pagination.find('button[data-page="'+ page +'"]').addClass('is-active');

              $('.search_loading').fadeOut(500);

              window.scroll(0, 0);

              $('.search-page-body.is-active article').remove();

              $('.search-page-body.is-active').prepend(data);
          }
      });
  });
});

jQuery(document).ready(function() {
  var filters = {};
  jQuery('.filters').on('change', function(event) {
      var $select = jQuery(event.target);
      var filterGroup = $select.attr('value-group');
      filters[filterGroup] = event.target.value;
      var filterValue = concatValues(filters);
      if (!filterValue) {
          filterValue = ".ghj-item"
      }
      jQuery(".ghj-item").hide();
      jQuery(filterValue).show();
      if (jQuery(filterValue).height() == 0 || jQuery(filterValue).height() == null) {
          jQuery(".greenhouse_job_noresults").show()
      } else {
          jQuery(".greenhouse_job_noresults").hide()
      }
  });
  function concatValues(obj) {
      var value = '';
      for (var prop in obj) {
          value += obj[prop]
      }
      return value
  }
  load_select2();
  jQuery("body").on("change", ".attachment", function() {
      var allowedFiles = [".doc", ".docx", ".pdf", ".rtf"];
      var fileUpload = jQuery(this);
      if (fileUpload.val() != '') {
          var validation_wrapper = fileUpload.parent().parent().find('.file_validate');
          var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(" + allowedFiles.join('|') + ")$");
          if (!regex.test(fileUpload.val().toLowerCase())) {
              validation_wrapper.text('Invalid file format');
              return !1
          }
      }
      validation_wrapper.text('');
      return !0
  });
  var key = 1;
  jQuery("#add_education").click(function() {
      const educationField = educationFields(key);
      jQuery(".education_section").append(educationField);
      load_select2();
      key++
  });
  jQuery("body").on("click", ".removeEducation", function() {
      jQuery(this).parent().remove()
  })
});
function viewDetails(dhis) {
  jQuery(dhis).parent().parent().parent().find(".job-description").toggleClass("job-description-show")
}
function viewGHSJForm() {
  jQuery(".ghj-form-wrapper").show()
}
function educationFields(key = 0) {
  var education = '<div class="education">\
  <a class="removeEducation" href="javascript:void(0);" title="Remove"><span>X</span></a>\
  <div class="ghj-field">\
    <label>School <span>*</sapn></label>\
    <select class="education-school-data" name="job_application[educations][' + key + '][school_name_id]" required>\
      <option value="">Select a school</option>\
    </select>\
  </div>\
  <div class="ghj-field">\
    <label>Degree <span>*</sapn></label>\
    <select class="education-degree-data" name="job_application[educations][' + key + '][degree_id]" required>\
    </select>\
  </div>\
  <div class="ghj-field">\
    <label>Discipline <span>*</sapn></label>\
    <select class="education-discipline-data" name="job_application[educations][' + key + '][discipline_id]" required>\
    </select>\
  </div>\
  <div class="ghj-field">\
    <label>Start Date (Year<span>*</sapn>)</label>\
    <input type="text" name="job_application[educations][' + key + '][start_date][year]" placeholder="YYYY" required />\
  </div>\
  <div class="ghj-field">\
    <label>End Date (Year<span>*</sapn>)</label>\
    <input type="text" name="job_application[educations][' + key + '][end_date][year]" placeholder="YYYY" required />\
  </div>\
</div>';
  return education
}
function load_select2() {
  jQuery('.education-school-data').select2({
      ajax: {
          url: 'https://boards-api.greenhouse.io/v1/boards/neatorobotics/education/schools',
          data: function(params) {
              var query = {
                  term: params.term,
                  page: params.page || 1
              }
              return query
          },
          processResults: function(data, params) {
              params.page = params.page || 1;
              return {
                  results: data.items,
                  pagination: {
                      more: (params.page * 100) < data.meta.total_count
                  }
              }
          },
      },
      placeholder: 'Select a School',
  });
  jQuery('.education-degree-data').select2({
      ajax: {
          url: 'https://boards-api.greenhouse.io/v1/boards/neatorobotics/education/degrees',
          data: function(params) {
              var query = {
                  term: params.term,
                  page: params.page || 1
              }
              return query
          },
          processResults: function(data, params) {
              params.page = params.page || 1;
              return {
                  results: data.items,
                  pagination: {
                      more: (params.page * 100) < data.meta.total_count
                  }
              }
          },
      },
      placeholder: 'Select a School',
  });
  jQuery('.education-discipline-data').select2({
      ajax: {
          url: 'https://boards-api.greenhouse.io/v1/boards/neatorobotics/education/disciplines',
          data: function(params) {
              var query = {
                  term: params.term,
                  page: params.page || 1
              }
              return query
          },
          processResults: function(data, params) {
              params.page = params.page || 1;
              return {
                  results: data.items,
                  pagination: {
                      more: (params.page * 100) < data.meta.total_count
                  }
              }
          },
      },
      placeholder: 'Select a School',
  });
  jQuery("form#ghj-form").validate()
};


var settings = {
  "async": true,
  "crossDomain": true,
  "url": "https://boards-api.greenhouse.io/v1/boards/neatorobotics/jobs?content=true",
  "method": "GET",
  "headers": {
    "cache-control": "no-cache",
    "postman-token": "ad9c6548-a4f1-6a96-3dbd-7fc90926e164"
  }
}
$.ajax(settings).done(function (response) {
  useReturnData(response.jobs);
});
function viewDetails(dhis) {
  jQuery(dhis).parent().parent().parent().find(".job-description").toggleClass("job-description-show")
  
}
var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');
  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      // strip script/html tags
      var indexOf = str.indexOf("&lt;/p&gt;\n");
      str = str.substring(indexOf, str.length);
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }
    return str;
  }
  return decodeHTMLEntities;
})();



function useReturnData(data){
    for(let i = 0; i<data.length; i++ ){
      var departmentName;
      var locationName;
      var decodedHtmlContent = decodeEntities(data[i].content);
      // var trimmedContent = decodedHtmlContent.substring(0,350);
      const truncate = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;
      var trimmedContent = truncate(decodedHtmlContent,350,"...");
      if(data[i].departments[0]){
        departmentName = data[i].departments[0].name
      }else{
        departmentName = "";
      }
      if(data[i].location){
        locationName = data[i].location.name
      }else{
        locationName = "";
      }

      post = {
      department : departmentName,
      title : data[i].title,
      location : locationName,
      content : trimmedContent,
      id : data[i].id,
      internal_job_id : data[i].internal_job_id
  }
    const jobItems = document.querySelector(".greenhouse_job_items");
    if(jobItems){
      var jobItem = document.createElement('div'); // is a node
      jobItem.className = `greenhouse_job_item ghj-item ${post.department.toLowerCase().replace(/\s/g, '').replace(",","")} ${post.location.toLowerCase().replace(/\s/g, '').replace(",","")}`;
      jobItem.innerHTML = "<div class='greenhouse_job_item_details'><div clas='greenhouse_job_title'>"+ post.title +"</div><div clas='greenhouse_job_location'>"+ post.location +"</div><div clas='greenhouse_job_category'>" + post.department + "</div><div clas='greenhouse_job_button'><a href='javascript:void(0);' onclick='viewDetails(this);' class='viewDetails'>View details</a></div></div><div class='job-description job-description-desk'><p>"+ post.content +"</p><p></p><a href='/pages/job-board/?gh_jid=" + post.id + "'>Read more</a></div><div class='job-description job-description-mob'><p>"+ post.content +"<p></p><a href='/pages/job-board/?gh_jid=" + post.id + "'>Read more</a></div>";
      jobItems.appendChild(jobItem);
    }
  }
}

// Warranty page
class CustomSelect {
  constructor(id) {
      this.id = id;
      this.select = null;
  }
  setup() {
      this.select = document.querySelector(`#${this.id}`);
      if (this.select)
          this.setListener();
  }
  setListener() {
      const toggler = this.select.querySelector(".custom-select-toggler");
      const options = this.select.querySelectorAll(".custom-select-option");
      const select = toggler.parentElement;
      toggler.addEventListener("click", ()=>this.toggleSelectClass(select));
      options.forEach(option=>{
          option.addEventListener("click", ({target})=>{
              this.toggleSelectClass(select);
              this.setTogglerPlaceholder(toggler, target.innerText);
          }
          );
      }
      );
      document.addEventListener("click", ({target})=>{
          if (target.closest(`#${this.id}`))
              return;
          if (select.classList.contains("options-visible")) {
              this.toggleSelectClass(select);
          }
      }
      );
  }
  toggleSelectClass(select) {
      select.classList.toggle("options-visible");
  }
  setTogglerPlaceholder(toggler, placeholder) {
      const span = toggler.querySelector("span");
      span.innerText = placeholder;
  }
}
const repairCenterBlock = document.querySelector(".repair-center-block");
if (repairCenterBlock) {
    new CustomSelect("repair-country-selection").setup();
    const repairCenters = repairCenterBlock.querySelectorAll(".repair-center-item");
    const selectToggler = repairCenterBlock.querySelector(".custom-select-toggler .toggler-placeholder");
    const selectOptionsWrapper = repairCenterBlock.querySelector(".custom-select-option-wrapper");
    var Initindex = 0;
    // if (localizedStrings.currentLangCode == "de" || localizedStrings.currentLangCode == "fr") {
    //     Initindex = 1;
    // }
    let currentIndex = Initindex;
    const setCurrentIndex = index=>{
        currentIndex = index;
        repairCenters.forEach((_,i)=>{
            i === index ? repairCenters[i].classList.add("is-active") : repairCenters[i].classList.remove("is-active");
        }
        );
        setSelectPlaceholder(repairCenters[index].dataset.countryflag);
    }
    ;
    const setSelectPlaceholder = flag=>{
        let img = document.createElement("img");
        img.src = flag;
        selectToggler.innerHTML = "";
        selectToggler.append(img);
    }
    ;
    const setSelectOptions = (flag,country)=>{
        let button = document.createElement("button");
        let img = document.createElement("img");
        let p = document.createElement("p");
        button.classList.add("custom-select-option");
        img.src = flag;
        p.innerText = country;
        button.append(p, img);
        selectOptionsWrapper.append(button);
    }
    ;
    repairCenters.forEach((center,i)=>{
        let flag = center.dataset.countryflag;
        let country = center.dataset.countryname;
        if (i == Initindex)
            setSelectPlaceholder(flag);
        setSelectOptions(flag, country);
    }
    );
    [...selectOptionsWrapper.children].forEach((option,i)=>option.addEventListener("click", ()=>setCurrentIndex(i)));
    repairCenters[Initindex].classList.add("is-active");
}
// end warranty page  
const zen_files = document.getElementById('zen_files');
if (zen_files) {
    zen_files.onchange = function() {
        document.querySelector("#zendesk_field_zen_files_name").innerText = zen_files.files.item(0).name;
    };
}
const blogFilters = document.querySelector(".blog-entries-list-filters");
if (blogFilters) {
    new CustomSelect("blog-category-filter").setup();
}
$(window).on('resize orientationchange', function() {
$('.cgb-gallery-slides').slick('resize');
// $('.icon-bar__container').slick('resize');

});



//landing page slider 

const vacuumSlider = document.querySelector(".vacuum-slider");
if (vacuumSlider) {
  const slider = vacuumSlider.querySelector(".vacuum-slider-surfaces > div");
  const slides = slider.querySelectorAll("img");
  const selectors = vacuumSlider.querySelectorAll("nav button");
  const firstSlide = slides[0];
  const secondSlide = slides[1];
  const penultimateSlide = slides[slides.length - 2];
  const lastSlide = slides[slides.length - 1];
  const clonedFirst = firstSlide.cloneNode(true);
  const clonedSecond = secondSlide.cloneNode(true);
  const clonedPenultimate = penultimateSlide.cloneNode(true);
  const clonedLast = lastSlide.cloneNode(true);
  const prevBtn = vacuumSlider.querySelector(".slider-left-arrow");
  const nextBtn = vacuumSlider.querySelector(".slider-right-arrow");
  slider.append(clonedFirst, clonedSecond);
  slider.insertBefore(clonedLast, firstSlide);
  slider.insertBefore(clonedPenultimate, clonedLast);
  let currentIndex = 0;
  let allowShift = true;
  let slideSize = firstSlide.offsetWidth;
  let initialPos;
  function goToSlide(index, transition=true) {
    let step = slides[index].offsetLeft - slideSize;
    if (transition)
      slider.classList.add("shifting");
    slider.style.left = `${-step}px`;
    currentIndex = index;
    setActiveSelector(currentIndex);
  }
  function shiftSlide(direction="right") {
    slider.classList.add("shifting");
    if (allowShift) {
      initialPos = slider.offsetLeft;
      if (direction === "right") {
        slider.style.left = `${initialPos - slideSize}px`;
        currentIndex++;
      } else if (direction === "left") {
        slider.style.left = `${initialPos + slideSize}px`;
        currentIndex--;
      }
    }
    allowShift = false;
  }
  function checkIndex() {
    slider.classList.remove("shifting");
    if (currentIndex < 0) {
      slider.style.left = `${-(slides.length * slideSize)}px`;
      currentIndex = slides.length - 1;
    }
    if (currentIndex === slides.length) {
      slider.style.left = `${-(1 * slideSize)}px`;
      currentIndex = 0;
    }
    setActiveSelector(currentIndex);
    allowShift = true;
  }
  function setActiveSelector() {
    selectors.forEach((selector,i)=>{
      if (i === currentIndex) {
        if(selector.classList.contains("wood") || selector.classList.contains("tile")){
          document.querySelector(".vacuum-slider-image").classList.add("no-after");
        }
        else{
          document.querySelector(".vacuum-slider-image").classList.remove("no-after");
        }
        if(selector.classList.contains("carpet")){
          document.querySelector(".vacuum-slider-image").classList.add("no-before");
        }
        selector.classList.add("is-active");
      } else {
        selector.classList.remove("is-active");
      }
    }
                     );
  }
  function checkSizes() {
    if (firstSlide.offsetWidth === slideSize)
      return;
    slideSize = firstSlide.offsetWidth;
    goToSlide(currentIndex, false);
  }
  slider.addEventListener("transitionend", checkIndex);
  prevBtn.addEventListener("click", ()=>shiftSlide("left"));
  nextBtn.addEventListener("click", ()=>shiftSlide("right"));
  selectors.forEach((btn,i)=>btn.addEventListener("click", ()=>goToSlide(i)));
  window.addEventListener("resize", checkSizes);
  setActiveSelector(currentIndex);
}

// Script to optimize background images
document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;    
  
    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".custom-lazy");
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.classList.remove("custom-lazy");
            imageObserver.unobserve(image);
          }
        });
      });
  
      lazyloadImages.forEach(function(image) {
        imageObserver.observe(image);
      });
    } else {  
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".custom-lazy");
      
      function lazyload () {
        if(lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }    
  
        lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function(img) {
              if(img.offsetTop < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('custom-lazy');
              }
          });
          if(lazyloadImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
  
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  })

// Why a robot vacuum landing page
    $(".template-custom-clean .vacuum-features-card").click(function () {
      const scrolltoSection = "#" + this.dataset.section;
      const scrolltoSectionEl = document.querySelector(scrolltoSection) != null;
      if(scrolltoSectionEl){
        document.querySelector(scrolltoSection).scrollIntoView({ behavior: "smooth", block: 'center' });
      }
  });
$(document).ready(function(){
  if($(".product-description-expand-wrapper").length > 0)
  {
    if($(".product-description-wrapper ul").length > 0 || $(".product-description-wrapper ol").length > 0)
    {
      if($(".product-description-wrapper ul").length > 0)
      {
        if($(".product-description-wrapper ul li").length > 2)
        {
           $(".product-description-wrapper").addClass("hide-border");   
        }
        else
        {
          $(".product-description-expand-wrapper").hide();
        }
      }
      else
      {
        if($(".product-description-wrapper ol").length > 0)
        {
          if($(".product-description-wrapper ol li").length > 2)
          {
             $(".product-description-wrapper").addClass("hide-border");   
          }
          else
          {
            $(".product-description-expand-wrapper").hide();
          }
        }
        else
        {
          $(".product-description-expand-wrapper").hide();
        }
      }
    }
    else
    {
      $(".product-description-expand-wrapper").hide();
    } 
  }
  $(".product-description-expand-link.show-more").on("click", function(e){
    e.preventDefault();
    if($(this).parent().prev(".product-description-wrapper").length > 0)
    {
      $(this).parent().prev(".product-description-wrapper").addClass("show-all");
      $(this).css("display", "none");
      $(this).parent().find("a.show-less").css("display", "inline-block");
    }
  });
  $(".product-description-expand-link.show-less").on("click", function(e){
    e.preventDefault();
    if($(this).parent().prev(".product-description-wrapper").length > 0)
    {
      $(this).parent().prev(".product-description-wrapper").removeClass("show-all");
      $(this).css("display", "none");
      $(this).parent().find("a.show-more").css("display", "inline-block");
    }
  });
});